<template>
  <div>
    <!-- 添加或修改菜单对话框 -->
    <!--  :close-on-click-modal="false" -->
    <el-dialog
      :title="title"
      :visible.sync="open"
      append-to-body
      :fullscreen="true"
      :before-close="cancelOpen"
      width="90%"
      top="10px"
    >
      <!-- style="height: 80vh;" -->
      <div style="height: 80vh;width: 100%;position: relative;">
        <!-- <vue-office-excel :src="formurl" @rendered="renderedHandler" @error="errorHandler" /> -->
        <div
          id="luckysheet"
          style="margin: 0px;padding: 0px;width: 100%;height: 95%;"
        ></div>
        <!-- style="margin: 0px;padding: 0px;position: absolute;width: 100%;height: 100%;left: 0px;top: 0px;" -->
        <div
          style="width: 100%;text-align: center;margin-top:10px;z-index: 999;"
        >
          <el-button type="primary" @click="cancelOpen">Cancel</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import VueOfficeExcel from "@vue-office/excel";
import LuckyExcel from "luckyexcel";
import axios from "axios";
// import { asynLoad } from "@/utils/excel";
//引入相关样式
// import "@vue-office/excel/lib/index.css";
import Cookies from "js-cookie";
// var luckysheet = null;

export default {
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    form: {
      type: Object,
    },
    // deptList: {},
  },
  data() {
    return {
      formurl: "",
      excelView: "",
    };
  },

  created() {
    this.getOriginFile(); // 获取远端文件
  },
  methods: {
    cancelOpen() {
      this.$emit("cancel");
    },

    // 获取传递的url参数
    getComment() {
      var afterUrl = window.location.search;
      let str = afterUrl.split("?")[1].split("&");
      for (let i = 0; i < str.length; i++) {
        let a = str[i].split("=");
        this.obj[a[0]] = a[1];
      }
    },
    getOriginFile() {
      axios({
        url:
          window.SITE_CONFIG["apiUpURL"] +
          "/sys/sysstock/getAccessUrl?id=" +
          this.form.id,
        responseType: "blob",
        headers: {
          token: Cookies.get("token") || "",
        },
      })
        .then((res) => {
          if (res.data) {
            // var data = 'http://59.110.159.111/gpweb/HK.xlsx'
            const blob = new Blob([res.data]);
            const file = new File([blob], "fileName");
            this.init(file); // 开始渲染
          } else {
            this.$message({
              message: res.msg,
              type: "error",
              duration: 2000,
            });
            this.cancel();
          }
        })
        .catch((e) => {
          this.errorTitle = "文件解析失败，请下载后使用 Excel 打开或点击重试！";
          this.errStatus = 2;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 渲染方法，接受文件对象，如果是本地文件直接传入文件即可
    init(file) {
      luckysheet.destroy(); // 先销毁当前容器
      LuckyExcel.transformExcelToLucky(file, (exportJson) => {
        if (exportJson.sheets === null || !exportJson.sheets.length) {
          this.$message.error("无法读取excel文件的内容,当前不支持xls文件!");
          return;
        }
        console.log("exportJson.sheets", exportJson);
        exportJson.sheets[0].zoomRatio = 1;
        // exportJson.sheets[0].zoomRatio = 1.2;
        luckysheet.create({
          container: "luckysheet",
          showinfobar: false,
          showtoolbar: false,
          lang: "zh",
          data: exportJson.sheets,
          title: exportJson.info.name,
          userInfo: exportJson.info.name.creator,
          // devicePixelRatio: 0.8,
        });
        var numberList = luckysheet.getLuckysheetfile();
        for (let index = 0; index < numberList.length; index++) {
          const element = numberList[index];
          for (let i = 0; i < element.data.length; i++) {
            const elementI = element.data[i];
            for (let j = 0; j < elementI.length; j++) {
              const elementJ = elementI[j];
              if (elementJ && typeof elementJ.v == "number" && i > 23) {
                elementJ.ht = 2;
              }
            }
          }
        }
      });
    },
  },
};
</script>
<style>
#luckysheet {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 800px;
}
</style>
